import { merge } from 'lodash-es';
import getQueryParameter from './getQueryParameter';
import { reactive } from 'vue';
import SCORM from './SCORM';

export default function compileData(content: Content) {
  const defaultTags = { worddoc: false, ...content.tags };
  const urlTagsParameter = getQueryParameter('tags');
  const urlTagsObject = {};
  // default captions to true if the default language is not en-GB
  const captionsDefault =
    content['default-language'] && content['default-language'] !== 'en-GB'
      ? true
      : false;

  if (urlTagsParameter) {
    urlTagsParameter.split(/[+ ]+/).forEach(t => {
      urlTagsObject[t] = 'url';
    });
  }

  // build the suspend object
  const defaultSuspend: Suspend = reactive({
    completed: {},
    viewed: {},
    locked: {},
    edited: {},
    quizQuestions: {},
    questionOptions: {},
    bankQuestions: {},
    likertQuestions: {},
    insightsData: {},
    correctQuestions: {},
    inputs: {},
    mute: false,
    disableSfx: false,
    narrationMute: false,
    videoMute: false,
    captions: captionsDefault,
    transcript: false,
    locale: 'en-GB',
    tags: {},
    assessment: {},
    reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)')
      .matches,
    audioplaying: false
  });

  const tags = merge(defaultTags, urlTagsObject);
  const suspend: Suspend = merge(defaultSuspend, { tags }, SCORM.get());

  SCORM.set(suspend);

  return { suspend };
}
